var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse3, _g, _path24, _ellipse4, _g2, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel6Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 39.2695H417.467L402.072 269.065H387.053L376.539 39.2695Z",
    fill: "url(#paint0_linear_7088_3694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 484.596H417.467L402.072 254.8H387.053L376.539 484.596Z",
    fill: "url(#paint1_linear_7088_3694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.002 241.477L685.002 282.404L389.87 267.009L389.87 251.99L685.002 241.477Z",
    fill: "url(#paint2_linear_7088_3694)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 241.477L106.001 282.404L404.137 267.009L404.137 251.99L106.001 241.477Z",
    fill: "url(#paint3_linear_7088_3694)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557.974 502.412L522.529 522.876L388.295 259.589L401.302 252.079L557.974 502.412Z",
    fill: "url(#paint4_linear_7088_3694)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 0.992189L216.679 21.456L379.079 271.95L392.087 264.44L252.124 0.992189Z",
    fill: "url(#paint5_linear_7088_3694)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.448 388.959L635.984 424.403L388.09 263.506L395.599 250.499L656.448 388.959Z",
    fill: "url(#paint6_linear_7088_3694)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 99.4746L118.204 134.919L384.095 270.654L391.605 257.647L138.668 99.4746Z",
    fill: "url(#paint7_linear_7088_3694)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.473 522.879L233.028 502.415L393.927 254.522L406.934 262.032L268.473 522.879Z",
    fill: "url(#paint8_linear_7088_3694)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.443 21.4531L537.998 0.989276L402.262 266.878L415.27 274.388L573.443 21.4531Z",
    fill: "url(#paint9_linear_7088_3694)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.019 424.402L134.555 388.958L397.844 254.725L405.354 267.732L155.019 424.402Z",
    fill: "url(#paint10_linear_7088_3694)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.916 134.92L651.452 99.4755L400.956 261.875L408.466 274.882L671.916 134.92Z",
    fill: "url(#paint11_linear_7088_3694)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 394.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint12_radial_7088_3694)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 394.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint13_radial_7088_3694)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7088_3694)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 150C280.553 150 331.704 172.969 396.784 172.969C461.864 172.969 507.129 150 507.129 150V240.65H280.553V150Z",
    fill: "#1E588E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 156.127C280.553 156.127 331.704 179.096 396.784 179.096C461.864 179.096 507.129 156.127 507.129 156.127V246.777H280.553V156.127Z",
    fill: "#243560"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M380.347 225.668L316.069 319.921L217 244.254L249.139 197.127L281.278 150L380.347 225.668Z",
    fill: "#2874BA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M409.536 225.668L473.814 319.921L572.883 244.253L508.605 150L409.536 225.668Z",
    fill: "#2874BA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M572.883 244.253L473.814 319.921L468.758 312.508L563.253 240.333L572.883 244.253Z",
    fill: "#2874BA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M508.605 150L409.536 225.668L414.592 233.081L509.087 160.906L508.605 150Z",
    fill: "#2874BA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M386.372 231.326L322.094 325.58L223.025 249.912L255.164 202.785L287.303 155.659L386.372 231.326Z",
    fill: "#2D4071"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M407.467 239.152L461.071 317.753L560.139 242.086L533.338 202.785L506.536 163.485L407.467 239.152Z",
    fill: "#2D4071"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217 244.255L316.069 319.923L321.125 312.51L226.629 240.335L217 244.255Z",
    fill: "#2874BA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M281.277 149.999L380.346 225.667L375.291 233.08L280.795 160.906L281.277 149.999Z",
    fill: "#2874BA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M490.93 277.432C490.93 330.273 448.093 373.11 395.252 373.11C342.411 373.11 299.575 330.273 299.575 277.432C299.575 224.591 342.411 181.755 395.252 181.755C448.093 181.755 490.93 224.591 490.93 277.432Z",
    fill: "#FFDE69",
    stroke: "#6E5600",
    strokeWidth: 1.58827
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7088_3694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 327,
    y: 214,
    width: 145,
    height: 145
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.35,
    cy: 286.136,
    rx: 71.9227,
    ry: 71.9227,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7088_3694)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.52,
    cy: 278.477,
    rx: 71.9227,
    ry: 71.9227,
    fill: "#C09525"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M396.018 350.235C436.471 350.235 469.585 318.5 469.585 278.965C469.585 239.429 436.471 207.694 396.018 207.694C355.564 207.694 322.45 239.429 322.45 278.965C322.45 318.5 355.564 350.235 396.018 350.235Z",
    fill: "#6F5600",
    stroke: "#D1A635",
    strokeWidth: 10.8503
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7088_3694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 219,
    width: 134,
    height: 134
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.161,
    cy: 285.859,
    rx: 66.6052,
    ry: 66.6052,
    fill: "#C28B37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7088_3694)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.614,
    cy: 278.765,
    rx: 66.6052,
    ry: 66.6052,
    fill: "#936A00"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M396.017 227.308L412.725 259.782L413.11 260.531L413.946 260.632L447.118 264.662L424.323 289.503L423.794 290.079L423.928 290.849L430.162 326.711L396.711 310.457L396.017 310.119L395.323 310.457L361.878 326.708L368.166 290.852L368.302 290.079L367.771 289.502L344.921 264.661L378.088 260.632L378.924 260.531L379.309 259.782L396.017 227.308Z",
    fill: "url(#paint14_linear_7088_3694)",
    stroke: "#7E6200",
    strokeWidth: 3.17654
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7088_3694",
    x: 215.756,
    y: 148.756,
    width: 375.793,
    height: 243.815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.71085,
    dy: 8.71085
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.97763
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7088_3694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7088_3694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7088_3694",
    x1: 397.003,
    y1: 39.2695,
    x2: 397.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7088_3694",
    x1: 397.003,
    y1: 484.596,
    x2: 397.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7088_3694",
    x1: 657.591,
    y1: 261.94,
    x2: 389.87,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7088_3694",
    x1: 110.131,
    y1: 261.94,
    x2: 404.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7088_3694",
    x1: 526.546,
    y1: 488.906,
    x2: 392.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7088_3694",
    x1: 236.466,
    y1: 14.8011,
    x2: 383.467,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7088_3694",
    x1: 622.478,
    y1: 392.976,
    x2: 390.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7088_3694",
    x1: 132.013,
    y1: 119.262,
    x2: 386.629,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7088_3694",
    x1: 264.456,
    y1: 488.909,
    x2: 398.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7088_3694",
    x1: 553.655,
    y1: 14.7982,
    x2: 406.654,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7088_3694",
    x1: 168.525,
    y1: 392.975,
    x2: 400.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7088_3694",
    x1: 658.107,
    y1: 119.263,
    x2: 403.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_7088_3694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 394.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#936A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_7088_3694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 394.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#936A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7088_3694",
    x1: 396.017,
    y1: 223.836,
    x2: 396.017,
    y2: 329.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE178"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6Badge);
export default __webpack_public_path__ + "static/media/Level6Badge.1840e3ffea56cf660248882b39bbc5fe.svg";
export { ForwardRef as ReactComponent };